import React, { useContext, useState } from 'react'
import { AuthContext, ThemeContext } from '../../../../auth';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { axiosAuth } from '../../../../api';


function ModalTambahPcpDetailDatabase({
    showAddPcpDetail,
    setShowAddPcpDetail,
    listCategory,
    formStyles,
    selectStyles,
    pcpData,
    accessToken,
    retrievePCPDetail
}) {

    const { userInfo } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [productName, setProductName] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [productDesc, setProductDesc] = useState('');
    const [duration, setDuration] = useState('');
    const [buyingPrice, setBuyingPrice] = useState('');
    const [sellingPrice, setSellingPrice] = useState('');
    const [qty, setQty] = useState('');

    const handleClose = () => {
        setShowAddPcpDetail(false);
        setProductName('');
        setSelectedCategory(null);
        setDuration('');
        setBuyingPrice('');
        setSellingPrice('');
        setQty('');
        setProductDesc('');
    };

    const categoryOptions = listCategory.map(category => ({
        value: category.id,
        label: category.categoryName,
    }));

    const handleSelectedCategory = selectedOption => {
        setSelectedCategory(selectedOption);
    };

    function handleChangeBuyingPrice(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setBuyingPrice(numericValue);
    };

    function handleChangeSellingPrice(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setSellingPrice(numericValue);
    };

    const handleFormSubmit = async (e) => {

        e.preventDefault();
        setIsSubmitting(true);
        setDisabled(true);

        const pcpDetailData = {
            productName: productName || '',
            categoryId: selectedCategory?.value,
            productDesc: productDesc || '',
            duration: duration || 0,
            buyingPrice: buyingPrice || 0,
            sellingPrice: sellingPrice || 0,
            quantity: parseInt(qty) || 0,
            pcpId: pcpData?.id,
            username: userInfo?.username,
            subtotal: parseInt(sellingPrice) * parseInt(qty)
        }

        try {

            const response = await axiosAuth.post(`/api/pcp/details`, pcpDetailData, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleClose();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil menambahkan Produk',
                showConfirmButton: true,
            });

            retrievePCPDetail();

            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {

            console.error(err);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat menambahkan Produk',
            });

            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }

    };

    return (
        <Modal
            show={showAddPcpDetail}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size='md'
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222', }}>
                    Tambah PCP Produk
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleFormSubmit} >
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='productName'>Nama Produk*</Form.Label>
                        <Form.Control
                            id='productName'
                            type='text'
                            onChange={(e) => setProductName(e.target.value)}
                            value={productName}
                            required
                            placeholder='Nama Produk'
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='category'>Jenis Produk*</Form.Label>
                        <Select
                            id='category'
                            options={categoryOptions}
                            required
                            value={selectedCategory}
                            onChange={handleSelectedCategory}
                            styles={selectStyles}
                            placeholder='Pilih Jenis Produk'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='spec'>Spesifikasi</Form.Label>
                        <Form.Control
                            id='spec'
                            as='textarea'
                            rows={4}
                            onChange={(e) => setProductDesc(e.target.value)}
                            value={productDesc}
                            style={formStyles.input}
                            placeholder='Spesifikasi'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='buyingPrice'>Harga Beli*</Form.Label>
                        <Form.Control
                            id='buyingPrice'
                            type='text'
                            onChange={handleChangeBuyingPrice}
                            value={`Rp ${buyingPrice ? buyingPrice.toLocaleString('id-ID') : '0,00'}`}
                            required
                            placeholder='Harga Beli'
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='sellingPrice'>Harga Jual*</Form.Label>
                        <Form.Control
                            id='sellingPrice'
                            type='text'
                            onChange={handleChangeSellingPrice}
                            value={`Rp ${sellingPrice ? sellingPrice.toLocaleString('id-ID') : '0,00'}`}
                            required
                            placeholder='Harga Jual'
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='qty'>Qty*</Form.Label>
                        <Form.Control
                            id='qty'
                            type='text'
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    setQty(value);
                                }
                            }}
                            value={qty}
                            required
                            style={formStyles.input}
                            placeholder='Jumlah'
                        />
                    </Form.Group>
                    <div className="d-grid gap-2 mt-4 mb-2">
                        {isSubmitting ? (
                            <Button
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled
                            >
                                <Spinner
                                    animation="border"
                                    size='sm'
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled={
                                    disabled ||
                                    !productName ||
                                    !selectedCategory ||
                                    !sellingPrice ||
                                    !qty
                                }
                            >
                                Simpan
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalTambahPcpDetailDatabase
